module.exports = __webpack_public_path__ + "static/media/bg-l6.9ed7282d.png";